const generateLinks = (data, root = '') => {
  const result = {}

  Object.keys(data).forEach((key) => {
    const value = data[key]

    if (typeof value === 'object') {
      result[key] = generateLinks(value, `${root}${data.root || ''}`)
    }
    else {
      result[key] = key === 'root'
        ? `${root}${value}`
        : `${root}${data.root || ''}${value}`
    }
  })

  return result
}

const links = {
  marketplace: {
    root: '/marketplace',
    register: '/register',
    login: '/login',
    order: '/order/:orderId',
    privacy: '/privacy',

    health: '/health', // test route
    
    redirects: {
      sport: {
        root: '/sport',
        mc: {
          root: '/mc',
          pool: '/pool',
          fitness: '/fitness',
          tennis: '/tennis',
        },
      },
      edu: {
        root: '/edu',
        food: '/food',
      },
    },

    admin: {
      root: '/admin',

      // superadmin
      areaConfig: '/area-config',

      // sport
      ticket: '/ticket',
      report: '/report',
      learn: {
        root: '/learn',

        groupsConfig: '/groups-config',
        groupsAdd: '/groups-add',
        calculate: '/calculate',
        tariff: '/tariff',
        subscribers: '/subscribers',
      },
      statisticsConfig: '/statistics-config',
      tariffConfig: '/tariff-config',
      scheduleConfig: '/schedule-config',
      scheduleInput: '/schedule-input',
      scheduleView: '/schedule-view',
      serviceConfig: '/service-config',

      // school food
      catalog: '/catalog',
      categories: '/categories',
      registry: '/registry',
      reportEdu: '/report-edu',
      configDays: '/config-days',
      configSchools: '/config-school',
      configSchoolStages: '/config-school-stages',
      configAccess: '/config-access',
      bulkCancel: '/bulk-cancel',
      orderStatus: '/order-status',
    },

    customer: {
      root: '/customer',

      // sport
      schedule: '/schedule',
      ticket: '/ticket',
      learn: '/learn',
      cancel: '/cancel',
      info: '/info',

      // school food
      orderFood: '/order-food',
      cancelFood: '/cancel-food',

      // movie
      area: '/area/:areaId',
      movie: '/movie/:movieId'
    },

    cashier: {
      root: '/cashier',

      // sport
      schedule: '/schedule',
      ticket: '/ticket',
      learn: {
        root: '/learn',
        sale: '/sale',
      },
      cancel: '/cancel',

      // school food
      control: '/control',
      registry: '/registry',
      config: '/config',
      cancelFood: '/cancel-food',
      sales: '/sales',
    },
  },
  lscSchedules: {
    root: '/lsc-schedules',
    routes: '/routes',
    drivers: {
      root: '/drivers',
      schedule: '/schedule',
    },
    conductors: {
      root: '/conductors',
      schedule: '/schedule',
    },
    buses: {
      root: '/autobus',
      schedule: '/schedule',
    },
    schedule: {
      root: '/schedule',
      old: '/old',
      print: '/print'
    },
  },
  lscTransportControl: {
    root: '/lsc-transport-control',
    report: '/report',
    violation: '/violation',
    deviation: '/deviation',
  },
  lscVideoDownload: {
    root: '/lsc-video-download',
  },
  // voting: {
  //   root: '/voting',
  //   project: '/project/:projectId',
  //   admin: {
  //     root: '/admin',
  //     add: '/add',
  //     edit: '/edit/:editId',
  //   },
  // },
  emergencyAlert: {
    root: '/emergency-alert',
    archive: '/archive',
  },
  dashboard: {
    root: '/dashboard',
    statistic: '/statistic',
  },
  welcome: {
    root: '/welcome',
  },
  asudd: {
    root: '/asud',
  },
  heroes: {
    root: '/heroes',
    my: '/my',
    moderate: '/moderate',
  },
  accessible: {
    root: '/accessible',
  },
  transport: {
    root: '/transport',
    plan: '/plan',
    plan2: '/plan2',
    schedule: '/schedule',
    // control: '/control',
    config: '/config',
  },
  bus: {
    root: '/bus-new',
  },
  cityEconomy: {
    root: '/cityEconomy',
    reportOperations: '/report-operations',
    reportEconomy: '/report-economy',
  },
  sensorManager: {
    root: '/sensor-manager',
    config: '/config',
  },
}


export default generateLinks(links)
